import React from "react";
import Typography from "@material-ui/core/Typography";
const OpenClosePeriod = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Open Close Period
      </Typography>
      <Typography paragraph variant="h5">
        Perform accounting fiscal period month-end closing process
      </Typography>
      <Typography paragraph variant="body1">
        Open Close Period is one of the features under the Finance module to
        manage the month-end closing period before starting a new transaction
        each month to consolidate previous transactions for monthly or yearly
        report purposes. It contains any information regarding the fiscal period
        statuses and the timestamp of the closing period activity.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Fiscal Period
        list. It is displayed like a table that contains download functions,
        sort, filter, fiscal year searching, auto fiscal period closing and
        global search on the header area, and contains data navigation and
        refresh function on the footer area. The data column that appears in
        this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Year</b>
        <br />
        Indicates the year of the Fiscal Period.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Month</b>
        <br />
        Indicates the month of the Fiscal Period.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Period Status</b>
        <br />
        Indicates the status of the Fiscal Period. There are 3 statuses: Open,
        Closed, and Inactive.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Opening Date</b>
        <br />
        Indicates the opening date of the Fiscal Period
      </Typography>
      <Typography paragraph variant="body1">
        <b>Closing Date</b>
        <br />
        Indicates the closing date of the Fiscal Period
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there is 1 button that appear on each row of Fiscal Period data
        with specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Fiscal Period Status</b>
        <br />
        This button only appears if the Period status is 'Open' or 'Inactive'.
        It is used to open or close the fiscal period.
      </Typography>
    </React.Fragment>
  );
};

export default OpenClosePeriod;
